import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

const NotificationCenterLoadingState = (): JSX.Element => (
  <div
    className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border-default
      bg-bg-surface-alt px-6 py-10 text-center"
    aria-busy="true"
  >
    <Loader2 className="mx-auto mb-3 size-8 animate-spin text-brand-navy" aria-hidden />
    <p className="m-0 max-w-md text-sm text-text-muted font-body">Cargando proyectos…</p>
  </div>
);

export default NotificationCenterLoadingState;
